import cloudinaryRuntime_36F_45LjNRMfhWDgVQSaOQVul4SvQWiNL23MSPUTHpfe76E from '/opt/build/repo/node_modules/.pnpm/@nuxt+image@2.2.1_@nuxt+schema@4.6.3_@types+node@26.5.0_confbox@0.3.1_dotenv@17.4.2_gig_c3c33e1e009e96544f457dbf5e646570/node_modules/@nuxt/image/dist/runtime/providers/cloudinary'
import netlifyRuntime_367BSYMPwpJO03WB55ROgm2tfX9bUc_45as3uO_PhckxttA from '/opt/build/repo/node_modules/.pnpm/@nuxt+image@2.2.1_@nuxt+schema@4.6.3_@types+node@26.5.0_confbox@0.3.1_dotenv@17.4.2_gig_c3c33e1e009e96544f457dbf5e646570/node_modules/@nuxt/image/dist/runtime/providers/netlifyImageCdn'

export const imageOptions = {
  screens: {"sm":640,"md":768,"lg":1024,"xl":1280,"2xl":1536,"xs":320,"xxl":1920},
  presets: {},
  domains: [],
  alias: {},
  densities: [1,2],
  format: ["webp"],
  quality: undefined,
  /** @type {"netlify"} */
  provider: "netlify",
  providers: {
      ['cloudinary']: { setup: cloudinaryRuntime_36F_45LjNRMfhWDgVQSaOQVul4SvQWiNL23MSPUTHpfe76E, defaults: {"baseURL":"https://res.cloudinary.com/djurensratt/image/upload"} },
  ['netlify']: { setup: netlifyRuntime_367BSYMPwpJO03WB55ROgm2tfX9bUc_45as3uO_PhckxttA, defaults: {} }
  }
}
